<template>
  <button class="btn | fixed right-gutter bottom-gutter z-max">Demander la création d'un projet</button>
</template>
